import { CollectionInfoModel } from "@phdsoft/common";
import { Collection } from "./Collection";
import { TemporalCollection } from "./TemporalCollection";
import { NonWorkableElement } from "../SectionElements/NonWorkableElement";
import * as THREE from '@phdsoft/three';

export class WeightTemporalElementsCampaign extends TemporalCollection {
  private _insertionMethod: string;

  public get insertionMethod(): string {
    return this._insertionMethod;
  }
  public set insertionMethod(value: string) {
    this._insertionMethod = value;
  }

  private _elementName: string;

  public get elementName(): string {
    return this._elementName;
  }
  public set elementName(value: string) {
    this._elementName = value;
  }
  
  private _SphereGroup : THREE.Group;
  public get SphereGroup() : THREE.Group {
    return this._SphereGroup;
  }
  public set SphereGroup(v : THREE.Group) {
    this._SphereGroup = v;
  }  

  private _boxMeshesGroup : THREE.Group;
  public get boxMeshesGroup() : THREE.Group {
    return this._boxMeshesGroup;
  }
  public set boxMeshesGroup(v : THREE.Group) {
    this._boxMeshesGroup = v;
  }   

  constructor(date: Date, collectionInfoModel: CollectionInfoModel, sphereGroup:THREE.Group, boxGroup:THREE.Group) {
    super(date);
    this.Type = 'WeightTemporalElementsCampaign';
    this.CollectionInfoModel = collectionInfoModel;
    this._SphereGroup = sphereGroup;
    this._boxMeshesGroup = boxGroup;
    this.group.add(sphereGroup);
    this.group.add(boxGroup);
  }

  public override addModelTemporalElement(element:NonWorkableElement):void{
    this.modelTemporalElements.push(element);
    this._boxMeshesGroup.add(element.SurfaceDesign);
  }

  public clearWeightMeasurementToolMode(){
    // this.graphics.scene.remove(this._spherePointsGroup);
    // this.graphics.scene.remove(this._boxMeshesGroup);
    this.disposeGroup();
    for (let index = this.boxMeshesGroup.children.length-1; index >= 0; index--) {
      const element = this.boxMeshesGroup.children[index];
      this.boxMeshesGroup.remove(element);
      (element as THREE.Mesh).geometry.dispose()
    }
  }

  private disposeGroup(){
    for (let index = this.SphereGroup.children.length-1; index >= 0; index--) {
      const element = this.SphereGroup.children[index];
      this.SphereGroup.remove(element);
      (element as THREE.Mesh).geometry.dispose()
    }
    // this.spherePointsGroup.children = []
  }
}
